import { Icon } from './Icon'
import { linkWhatsApp } from '../config'

type Plano = {
  icone: string
  nome: string
  sub: string
  itens: string[]
  destaque?: boolean
  atraso?: string
}

const PLANOS: Plano[] = [
  {
    icone: 'chart', nome: 'Plano Pro', sub: 'O essencial para estruturar sua operação.',
    itens: ['Estruturação iFood ou 99 Food', 'Cadastro e configuração', 'Suporte por WhatsApp', 'Indicado para quem está começando'],
  },
  {
    icone: 'target', nome: 'Plano Max', sub: 'Mais estratégia e acompanhamento.', destaque: true, atraso: '90',
    itens: ['Estruturação iFood e 99 Food', 'Gestão de anúncios (ADS)', 'Relatórios mensais', 'Suporte prioritário'],
  },
  {
    icone: 'trophy', nome: 'Plano Premium', sub: 'Gestão completa e crescimento contínuo.', atraso: '180',
    itens: ['Todos os produtos da Skyenex', 'Acompanhamento estratégico', 'Consultoria especializada', 'Suporte dedicado'],
  },
]

export function Plans() {
  return (
    <section className="plans" id="planos">
      <div className="shell plans__inner">
        <div className="plans__head">
          <p className="eyebrow eyebrow--dark" data-reveal="up"><i />Nossos planos</p>
          <h2 className="h2" data-reveal="mask">
            Soluções para<br />cada momento<br /><span className="accent">do seu negócio.</span>
          </h2>
          <p data-reveal="up" data-delay="130">
            Planos pensados para atender desde quem está começando até operações mais avançadas.
          </p>
        </div>

        <div className="plans__grid">
          {PLANOS.map((p) => (
            <article
              className={`plan${p.destaque ? ' plan--featured' : ''}`}
              data-reveal="up"
              data-delay={p.atraso}
              key={p.nome}
            >
              {p.destaque && <span className="plan__tag">Mais escolhido</span>}
              <h3><span className="plan__ico"><Icon name={p.icone} /></span>{p.nome}</h3>
              <p className="plan__sub">{p.sub}</p>
              <ul className="checks checks--plan">
                {p.itens.map((i) => <li key={i}>{i}</li>)}
              </ul>
              <a href={linkWhatsApp()} className="btn btn--primary btn--block">Quero esse plano</a>
            </article>
          ))}

          <aside className="plans__help" data-reveal="up" data-delay="260">
            <h3>Não sabe qual plano<br />é ideal para você?</h3>
            <p>Fale com um especialista e receba uma recomendação personalizada.</p>
            <a href={linkWhatsApp()} className="btn btn--wa btn--block">
              <Icon name="wa" className="ico" /> Falar no WhatsApp
            </a>
            <small className="plans__note">
              Cada plano é ajustado conforme a necessidade da operação. Consulte os valores com um especialista.
            </small>
          </aside>
        </div>
      </div>
    </section>
  )
}
